export const initialState = {
  questData: null,
  questModalVisible: false,
  questAnswer: null,
  questPointsAnimationVisible: false,
};
